module.exports = __webpack_public_path__ + "static/media/parallax.74f97ae2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/images/parallax.jpg
 ** module id = 433
 ** module chunks = 0
 **/